exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-resizable-top[data-v-da6580c0] {\n    overflow: hidden;\n    max-height: 75%;\n}\n.card-resizable-top[data-v-da6580c0]::before {\n    content: '';\n    background-color: transparent;\n    width: 100%;\n    height: 5px;\n    cursor: ns-resize;\n    background-color: #343a40 !important;\n}\n.card-body[data-v-da6580c0] { \n    padding: 0;\n}\n.output-messages[data-v-da6580c0] {\n    height: 90%;\n    overflow: auto !important;\n}\n\n", ""]);

// exports
